import * as React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

const variants = [
    'h1',
    'h3',
    'body1',
    'caption',
] as readonly TypographyProps['variant'][];

function TypographyDemo(props: { loading?: boolean }) {
    const { loading = false } = props;

    return (
        <div>
            {variants.map((variant) => (
                <Typography component="div" key={variant} variant={variant}>
                    <div style={{ height: 10 }}></div>
                    <Skeleton variant="rectangular" width={210} height={20} />
                    <div style={{ height: 10 }}></div>
                    <Skeleton variant="rounded" width={210} height={20} />
                </Typography>
            ))}
        </div>
    );
}

export default function SkeletonTypography() {
    return (
        <Grid container spacing={12}>
            <Grid item xs>
                <TypographyDemo loading />
            </Grid>
            <Grid item xs>
                <TypographyDemo />
            </Grid>
            <Grid item xs>
                <TypographyDemo loading />
            </Grid>
            <Grid item xs>
                <TypographyDemo />
            </Grid>
        </Grid>
    );
}